var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46967 5.16425C0.176777 5.45714 0.176777 5.93202 0.46967 6.22491L5.24264 10.9979C5.53553 11.2908 6.01041 11.2908 6.3033 10.9979C6.59619 10.705 6.59619 10.2301 6.3033 9.93722L2.06066 5.69458L6.3033 1.45194C6.59619 1.15905 6.59619 0.684173 6.3033 0.391279C6.01041 0.0983858 5.53553 0.0983858 5.24264 0.391279L0.46967 5.16425ZM13 4.94458L1 4.94458V6.44458L13 6.44458V4.94458Z",
    fill: "#2E375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.0a0286ae48f2a1202f5a7d7ca51a15f6.svg";
export { ForwardRef as ReactComponent };